import { DataTypesAPIResponse } from '../components/fields/FieldsSettings/FieldsSettingsTypes';

/**
 * Transform the API response for data types into a more usable format.
 *
 * @param {DataTypesAPIResponse[] | undefined} dataTypesResponse - The API response for available data types.
 * @param {string | undefined} fieldDataType - The specific data type we're interested in (e.g., 'date', 'amount').
 * @returns {object | undefined} - Returns an object with the options for the specific data type or undefined if not found.
 */
export const getDataTypeOptionsFromQuery = (
  dataTypesResponse?: DataTypesAPIResponse[],
  fieldDataType?: string
) => {
  // Check if the required arguments are provided
  if (!dataTypesResponse || !fieldDataType) {
    return undefined;
  }

  // Find the configuration for the specific data type from the API response
  const dataTypeConfig = dataTypesResponse.find((dt) => dt.name === fieldDataType);

  // If dataTypeConfig is not found, return undefined
  if (!dataTypeConfig) {
    return undefined;
  }

  // Return the options available for the specific data type
  return {
    order: dataTypeConfig?.options?.order,
    decimalSymbol: dataTypeConfig?.options?.decimalSymbol,
    thousandsGrouping: dataTypeConfig?.options?.thousandsGrouping,
  };
};
